<script>
import appbarMixin from '@/v-shop/mixins/appbarMixin'
import hooksMixin from '@/v-shop/mixins/hooks-mixin'

export default {
	mixins: [appbarMixin, hooksMixin('AppBarButtons')],
	props: {
		dense: Boolean,
		cartIconColor: String,
		accountIconColor: String,
		favIconColor: String,
		noUserBtnText: {
			type: Boolean,
			default: false,
		},
		noWishlistBtnText: {
			type: Boolean,
			default: false,
		},
		noCartBtnText: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.dense ? 20 : 25
		},
		btnClass() {
			return this.dense ? 'px-1' : 'px-2'
		},
	},
	watch: {
		cartAutoRemovals: {
			handler(newVal) {
				this.showCartAlert = newVal?.length
			},
			immediate: true,
		},
	},
	methods: {
		showCartAutoRemovalsModal() {
			this.showCartAutoRemovals = true
			this.showCartAlert = false
		},
	},
}
</script>

<template>
	<div class="appbar__buttons d-flex align-center justify-end">
		<hook zone="user">
			<AppBar-ButtonLogin
				:hide-text="noUserBtnText"
				:icon-color="accountIconColor"
				:btn-class="btnClass"
				:icon-size="iconSize"
			/>
		</hook>
		<hook zone="wishlist">
			<AppBar-ButtonWishlist
				:hide-text="noWishlistBtnText"
				:icon-color="favIconColor"
				:btn-class="btnClass"
				:icon-size="iconSize"
			/>
		</hook>
		<hook zone="cart">
			<AppBar-ButtonCart
				:hide-text="noCartBtnText"
				:icon-color="cartIconColor || $vars.basetext"
				:btn-class="btnClass"
				:icon-size="iconSize"
			/>
		</hook>
	</div>
</template>

